/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import GroupCards from '../GroupCards';
import * as Ui from './styles';

const propTypes = {
  maximizedCard: PropTypes.string,
  onSelect: PropTypes.func,
  onMaximize: PropTypes.func,
  onMinimize: PropTypes.func,
  theme: PropTypes.object.isRequired,
};

const defaultProps = {
  maximizedCard: null,
  onSelect: null,
  onMaximize: null,
  onMinimize: null,
};

function ContextualGroupCards(props) {
  // props from redux
  const { activeSurvey } = props;
  // props from parent component
  const {
    theme,
  } = props;

  // props from parent to maximization control
  const {
    maximizedCard,
    onMaximize,
    onMinimize,
  } = props;

  return (
    <Ui.Container isFullScreen={!!maximizedCard}>
      {/* cards */}
      <Ui.GroupSection className="cards">
        <GroupCards
          customerId={activeSurvey.client ? activeSurvey.client.id : null}
          surveyId={activeSurvey.survey && activeSurvey.survey.id}
          surveyTitle={activeSurvey.survey && activeSurvey.survey.titulo}
          questionId={activeSurvey.question && activeSurvey.question.id}
          questionTitle={activeSurvey.question && activeSurvey.question.enunciado}
          maximizedCard={maximizedCard}
          onMaximize={onMaximize}
          onMinimize={onMinimize}
          theme={theme}
        />
      </Ui.GroupSection>
    </Ui.Container>
  );
}

ContextualGroupCards.propTypes = propTypes;
ContextualGroupCards.defaultProps = defaultProps;

const mapStateToProps = (state) => {
  const { activeSurvey } = state;
  return {
    activeSurvey,
  };
};

export default connect(mapStateToProps)(ContextualGroupCards);
